import { useMediaQuery } from "react-responsive";

export const MOBILE_BREAKPOINT = 743;

export default function useIsMobile(mobileScreenSize = MOBILE_BREAKPOINT) {
  return useMediaQuery({ query: `(width <= ${mobileScreenSize}px)` });
}
